import React from "react";

import Lottie from "react-lottie";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import googlePlayButton from "../../assets/images/googlePlayButton.png";
import * as globeAnimation from "./Geo vpn - connecting.json";
import StateOverview from "./components/stateoverview/StateOverview";

export default function HeroSection() {
  const notify = () => {
    toast.dismiss(); // Dismiss any existing toasts
    toast("This feature will be available soon. Stay tuned for updates.");
  };

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: globeAnimation,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  return (
    <section className="container mx-auto mb-[40px] mt-[calc(40px-25px)] md:mb-[85px] md:mt-[calc(75px-40px)] 2xl:mb-[160px] 2xl:mt-[calc(140px-35px)]">
      <div className="flex flex-col-reverse items-center justify-between md:flex-row">
        <div className="w-full md:w-[50%]">
          <p className="text-center font-manrope text-[20px] font-extrabold leading-[28px] text-[#333333] md:text-left md:text-[28px] md:font-[800] md:leading-[38px] 2xl:text-start 2xl:text-[42px] 2xl:leading-[54px]">
            Your Gateway to a Safer & Fastest Internet!{" "}
          </p>
          <p className="mb-[16px] mt-[16px] text-center font-manrope text-[13px] font-semibold leading-[20px] text-[#666A7C] md:mb-[24px] md:mt-[18px] md:text-left md:text-[15px] md:font-[600] md:leading-[22px] 2xl:mb-[36px] 2xl:mt-[24px] 2xl:text-start 2xl:text-[18px] 2xl:leading-[28px]">
            Fast, Secure, and Private Connections at Your Fingertips. Join
            Millions Already Experiencing True Online Freedom.
          </p>

          <div className="flex flex-row justify-center gap-[16px] md:justify-start md:gap-[32px]">
            <button
              className="h-[40px] w-[105px] text-nowrap rounded-[34px] bg-[#5072F1] font-manrope text-[11px] font-extrabold leading-[36px] text-[#FFFFFF] md:h-auto md:min-w-[137px] md:rounded-[40px] md:px-[28px] md:py-[10px] md:text-[12px] md:leading-[19.2px] 2xl:w-auto 2xl:px-[44px] 2xl:py-[14px] 2xl:text-[15px] 2xl:leading-[24px]"
              onClick={notify}
            >
              Explore More
            </button>

            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://play.google.com/store/apps/details?id=com.fast.secure.proxyvpn.unlimitedproxy.security&hl=en_US&gl=US"
              className="cursor-pointer"
            >
              <img
                src={googlePlayButton}
                alt="Download from Google Play"
                className="h-[40px] min-w-[112px] md:h-[40px] md:w-[107px] 2xl:h-[60px] 2xl:w-[170px]"
              />
            </a>
          </div>
        </div>

        <div className="w-[220px] sm:w-[260px] md:w-[340px] lg:w-[380px] 2xl:w-[420px] mx-auto md:ml-auto flex justify-center items-center">
          <Lottie options={defaultOptions} isClickToPauseDisabled={true} />
        </div>
      </div>
      <StateOverview />
      <ToastContainer />
    </section>
  );
}
